import { useEffect, useRef, useState, memo } from 'react';

const SectionReveal = memo(
  ({
    children,
    className = '',
    animation = 'fade-up',
    delay = 0,
  }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      const element = ref.current;

      if (!element) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);

            // После появления больше не наблюдаем
            observer.unobserve(element);
          }
        },
        {
          threshold: 0.01,
          rootMargin: '80px 0px',
        }
      );

      observer.observe(element);

      return () => {
        observer.disconnect();
      };
    }, []);

    /*
     * Начальные позиции анимаций
     */
    const animationClasses = {
      'fade-up': 'translate-y-8',
      'fade-down': '-translate-y-8',
      'fade-left': '-translate-x-8',
      'fade-right': 'translate-x-8',
      'fade-in': '',
      'zoom-in': 'scale-95',
      'zoom-out': 'scale-105',
    };

    const initialTransform =
      animationClasses[animation] || 'translate-y-8';

    return (
      <div
        ref={ref}
        className={`
          ${className}
          transition-[opacity,transform]
          duration-700
          ease-out
          ${
            isVisible
              ? 'opacity-100 translate-x-0 translate-y-0 scale-100'
              : `opacity-0 ${initialTransform}`
          }
        `}
        style={{
          transitionDelay: `${delay}ms`,
        }}
      >
        {children}
      </div>
    );
  }
);

SectionReveal.displayName = 'SectionReveal';

export default SectionReveal;